import "../scss/main.scss";
import Common from "./common";
import loadPageFile from "./loadPage";

class Start {
  constructor() {
    this.init();
    Common();
  }
  async init() {
    await loadPageFile();
  }
}

export { Start };
